import FontPicker from "font-picker-react";
import React, { useState } from "react";
import "./FontPicker.module.css";

const MyFontPicker = (props) => {
  const [font, setFont] = useState(props.def ? props.def : "Gibson-Light");

  return (
    <FontPicker
      apiKey="AIzaSyAxeO52o2FJSt_i3PgYGpo1vYqmtzalVkY"
      activeFontFamily={font}
      onChange={(nextFont) => {
        setFont(nextFont.family);
        props.changeFontFamily(nextFont.family);
      }}
    />
  );
};

export default MyFontPicker;
